import { withInstall } from '../../utils/install';
import Avatar from './index.vue';

export const IvueAvatar = withInstall(Avatar);
export default IvueAvatar;

export * from './index.vue';
